import { engagementCanvasTemplatePreview } from "../engagementCanvasTemplatePreview";
import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdStructuralTemplateCanvasTemplateUpsertCacheKeys: AllRouteEndpoints[] = [
  engagementCanvasTemplatePreview,
];
